export default defineNuxtPlugin(async (nuxtApp) => {
  // * Sólo en cliente

    
  if (!import.meta.client) return
  // await esperar(1000)

  // Desactivar el devtools
  // nuxtApp.options.devtools = { enabled: false }

  nuxtApp.hook('app:error', (err) => {
    consolo.error('[01.inicioDeCapa]', 'Error en app:', err)
  })
  nuxtApp.hook('vue:error', (err) => {
    consolo.error('[01.inicioDeCapa]', 'Error en vue:', err)
  })

  nuxtApp.hook('app:mounted', () => {
    // Inicio de la app
    alInit()
  })

  // * Detectar cambios de tema configurados en la página
  nuxtApp.hook('app:suspense:resolve', () => {
    refrescarTemaDeRuta()
  })

  nuxtApp.hook('page:loading:end', () => {
    refrescarTemaDeRuta()
  })

  // await esperar(1000)
})
